<template>
  <v-card :outlined="outlined" class="pt-0">
    <v-card-title class="subtitle-1 pb-0">
      {{ title }}
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col class="pa-0 label" :cols="twoColumn ? 9: 6" />
        <v-col v-if="threeColumn" class="pa-0 label" cols="3">{{ headers[0] }}</v-col>
        <v-col class="pa-0 label" cols="3">{{ lastColumnHeader }}</v-col>
      </v-row>
      <template v-for="(item, i) in items">
        <v-row :key="`it-${i}`">
          <v-col class="py-0" :cols="twoColumn ? 9: 6">
            <DisplayField label="" :value="item[firstColumnProp.name]" />
          </v-col>
          <v-col v-if="threeColumn" class="pa-0" cols="3">
            <DisplayField label="" :value="item[secondColumnProp.name]" :type="secondColumnProp.type" />
          </v-col>
          <v-col class="pa-0" cols="3">
            <DisplayField label="" :value="item[lastColumnProp.name]" :type="lastColumnProp.type" />
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<style scoped>

</style>

<script>
import DisplayField from '@/components/Shared/DisplayField.vue';

export default {
  name: 'SmallTableCard',
  components: { DisplayField },
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      required: true,
      type: Array
    },
    twoColumn: {
      required: false,
      type: Boolean,
      default: false
    },
    threeColumn: {
      required: false,
      type: Boolean,
      default: false
    },
    headers: {
      required: true,
      type: Array
    },
    fields: {
      required: true,
      type: Array
    },
    outlined: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  computed: {
    lastColumnHeader: function () {
      return this.twoColumn ? this.headers[0] : this.headers[1];
    },
    firstColumnProp: function () {
      return this.fields[0];
    },
    secondColumnProp: function () {
      return this.fields[1];
    },
    lastColumnProp: function () {
      return this.twoColumn ? this.fields[1] : this.fields[2];
    }
  }
};
</script>
